import { Fragment, h } from "preact";

import { renderHtml } from "../../helpers";
import i18n from "../../i18n";

import Button from "../Button.jsx";
import HeaderIcon from "../HeaderIcon.jsx";
import List from "../List.jsx";
import ListItem from "../ListItem.jsx";
import ProfileLink from "../ProfileLink.jsx";
import WhitepaperTeaser from "../WhitepaperTeaser.jsx";

const CommonPart = () => (
  <Fragment>
    <List class="mt-48 mb-32">
      <ListItem
        secondLine="StepStone is one of the most successful online job board businesses today and operates in over 20 countries"
        link="https://www.stepstone.com/en/"
        iconFront={<img src="/images/product_icons/icon_stepstone.png" />}
        iconBack="link"
      >
        Stepstone
      </ListItem>
      <ListItem
        secondLine="Indeed has become the catalyst for putting the world to work. Indeed is intensely passionate about delivering the right fit for every hire."
        link="https://www.indeed.com/"
        iconFront={<img src="/images/product_icons/icon_indeed.png" />}
        iconBack="link"
      >
        Indeed
      </ListItem>
    </List>
    <p class="t-body3">{i18n.t("products.job_search_no.second_part")}</p>
    <List class="mt-48 mb-32">
      <ListItem
        secondLine="English Jobs is a search engine for English-speaking professionals looking for opportunities in Germany or locals looking to work in a purely international environment."
        link="https://englishjobs.de/"
        iconFront={<img src="/images/product_icons/icon_english_jobs.png" />}
        iconBack="link"
      >
        English Jobs
      </ListItem>
      <ListItem
        secondLine="Next Station makes it easier for international candidates to meet the right companies, no matter where they are or want to go."
        link="https://www.nextstation.com"
        iconFront={<img src="/images/product_icons/icon_next_station.png" />}
        iconBack="link"
      >
        Next Station
      </ListItem>
      <ListItem
        secondLine="Academics is the leading job market and career guide for science and research in Germany, Austria and Switzerland."
        link="https://www.academics.com/"
        iconFront={<img src="/images/product_icons/icon_academics.png" />}
        iconBack="link"
      >
        Academics
      </ListItem>
    </List>
    <WhitepaperTeaser
      class="mt-48 mb-64"
      title="Job"
      description={i18n.t("whitepaperTeaser.job")}
      whitepaperId="finding-a-job-in-germany"
    />
  </Fragment>
);

export default {
  job_search_yes: ({ onNext, onRestart }) => {
    return (
      <section class="task-page">
        <HeaderIcon>job_finder</HeaderIcon>
        <h1 class="task-page__headline">
          {i18n.t("products.job_search_yes.title")}
        </h1>
        <p class="t-body3 mb-48">
          {i18n.t("products.job_search_yes.description")}
        </p>

        <Fragment>
          <ListItem number={1}>
            {i18n.t("products.job_search_yes.item_one")}
          </ListItem>
          <ListItem number={2}>
            {i18n.t("products.job_search_yes.item_two")}
          </ListItem>
          <ListItem number={3}>
            {i18n.t("products.job_search_yes.item_three")}
          </ListItem>
          <ListItem number={4}>
            {i18n.t("products.job_search_yes.item_four")}
          </ListItem>
        </Fragment>

        <WhitepaperTeaser
          class="mt-48 mb-48"
          title="Guide to Germany"
          description={i18n.t("whitepaperTeaser.guideToGermany")}
          whitepaperId="guide-to-germany"
        />

        <ProfileLink bordered />

        <p class="t-body3 mt-64">
          {i18n.t("products.job_search_yes.next_steps")}
        </p>

        <div class="task-page__buttons mt-64">
          <Button onClick={onNext}>{i18n.t("actions.done")}</Button>

          <Button text onClick={onRestart}>
            {i18n.t("actions.discard_result")}
          </Button>
        </div>
      </section>
    );
  },

  job_search_no: ({ onNext, onRestart }) => {
    return (
      <section class="task-page">
        <HeaderIcon>job_finder</HeaderIcon>
        <h1 class="task-page__headline">
          {renderHtml(i18n.t("products.job_search_no.title"))}
        </h1>

        <div class="task-page__content">
          <p>{renderHtml(i18n.t("products.job_search_no.description"))}</p>

          <CommonPart />

          <div class="task-page__buttons mb-48">
            <Button secondary onClick={onNext}>
              {i18n.t("actions.done")}
            </Button>
            <Button text class="mr-16" onClick={onRestart}>
              {i18n.t("actions.discard_result")}
            </Button>
          </div>
          <h6 class="t-h6 t-h6--margin">
            {i18n.t("products.job_search_no.not_found_title")}
          </h6>
          <p class="t-body3">
            {i18n.t("products.job_search_no.not_found_text")}
          </p>
        </div>

        <div class="task-page__buttons">
          <Button class="mr-16" onClick={onRestart}>
            {i18n.t("actions.ok")}
          </Button>
        </div>
      </section>
    );
  },
};
